var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.40204 1.49956C8.55699 -0.499853 11.4429 -0.499853 12.5979 1.49956L19.5259 13.4996C20.6808 15.4993 19.2377 17.9998 16.928 17.9998H3.07196C0.762143 17.9998 -0.681094 15.4993 0.474043 13.4996L7.40204 1.49956ZM9.13387 2.49994L2.20599 14.4997C1.82113 15.166 2.30177 15.9997 3.07196 15.9997H16.928C17.6981 15.9997 18.1789 15.1662 17.794 14.4999L10.866 2.49994C10.481 1.83362 9.51896 1.83362 9.13387 2.49994ZM9.99996 5.99975C10.5522 5.99975 11 6.44747 11 6.99975V8.99975C11 9.55204 10.5522 9.99975 9.99996 9.99975C9.44767 9.99975 8.99996 9.55204 8.99996 8.99975V6.99975C8.99996 6.44747 9.44767 5.99975 9.99996 5.99975ZM8.99996 12.9997C8.99996 12.4475 9.44767 11.9998 9.99996 11.9998H10.01C10.5622 11.9998 11.01 12.4475 11.01 12.9997C11.01 13.552 10.5622 13.9998 10.01 13.9998H9.99996C9.44767 13.9998 8.99996 13.552 8.99996 12.9997Z",
    fill: "#BC4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.1620732e57f491453dc3b5e10f8decb7.svg";
export { ForwardRef as ReactComponent };